import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

export default function MenuTitled({menu, style, setStyle, handleClose, setActiveController}) {
    const handleClick = (event, menu) => {
        handleClose(event, menu)
        setActiveController(menu)
    }

    const handleOut = (even, menu) => {
        let element = event.currentTarget
        setStyle()
    }

    const handleOver = (event, menu) => {
        let element = event.currentTarget
        let happen = {}
        
        happen[menu.key] = {
        	...style[menu.key],
        	...{
                background: "rgba(125,125,125, 0.25)"
            }
        }

        setStyle(happen)
    }

    return (<MenuItem 
    	key={menu.name} 
    	onMouseOut={(event) => handleOut(event, menu)} 
    	onClick={ (event) => handleClick(event, menu) } 
    	onMouseOver={ (event) => handleOver(event, menu) }
    >
        <Typography>{menu.name}</Typography>
    </MenuItem>)
}